import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './my-site-spinner.html';


export class MySiteSpinner extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-spinner';
    }

    static get properties() {
        return {
            show: {
                type: Boolean,
                observer: '_toggle'
            },
            caption: {
                type: String,
                value: ''
            }
        }
    }

    _toggle(newVal) {
        if(newVal)
            this.className = 'show';
        else
            this.className = '';
    }

}

window.customElements.define(MySiteSpinner.is, MySiteSpinner);